/**
 * E.164 phone helpers for the Profile page's Contact details card.
 *
 * The Hub's portal profile PATCH hard-asserts E.164 and 400s malformed
 * values, so the card pre-validates to give the applicant a usable message
 * without a round trip. Deliberately tiny — no libphonenumber; the Hub is
 * the authority and its 400 message is rendered verbatim on rejection.
 */

/** Strip the formatting characters people paste: spaces, dashes, dots, parens. */
export function normalizePhone(raw: string): string {
  return raw.replace(/[\s\-().]/g, '');
}

/** E.164: + then 8–15 digits, no leading zero. */
const E164 = /^\+[1-9]\d{7,14}$/;

/**
 * Strictly E.164 — a leading + is REQUIRED. Bare national numbers are
 * rejected on purpose, even 10-digit NANP ones the Hub would canonicalise
 * to +1…: our applicants are international, so a bare 10-digit number
 * starting 2-9 (e.g. a Nigerian "8031234567") is indistinguishable from a
 * US one and would be silently mis-filed as +1, leaving the applicant
 * uncontactable. Forcing the country code ("include your country code"
 * helper copy next to the input) removes that mis-attribution risk.
 */
export function isValidProfilePhone(raw: string): boolean {
  return E164.test(normalizePhone(raw));
}
